import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=7517afe6&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7517afe6')) {
      api.createRecord('7517afe6', component.options)
    } else {
      api.reload('7517afe6', component.options)
    }
    module.hot.accept("./TermsOfUse.vue?vue&type=template&id=7517afe6&", function () {
      api.rerender('7517afe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TermsOfUse.vue"
export default component.exports